import axios from './axios';

export const getAds = () => axios.get(`ads`).then(res => res.data);

export const saveAds = payload => axios.put('ads', payload).then(res => res.data);
